import { render, staticRenderFns } from "./deleteCommunity.vue?vue&type=template&id=b5dc01fe&scoped=true"
import script from "./deleteCommunity.vue?vue&type=script&lang=js"
export * from "./deleteCommunity.vue?vue&type=script&lang=js"
import style0 from "./deleteCommunity.vue?vue&type=style&index=0&id=b5dc01fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dc01fe",
  null
  
)

export default component.exports